<template>
  <a-drawer
    title="公告信息"
    v-model:open="navBarState.showNoticeInfoList"
    class="small"
    width="90%"
  >
    <a-tabs size="small" v-model:activeKey="noticeInfoState.activeKey">
      <a-tab-pane v-for="item in noticeInfoState.tabList" :key="item.key">
        <template #tab>
          <div>
            <FileTextOutlined class="inline-block align-middle" />
            <span class="inline-block align-middle">{{ item.title }}</span>
            <a-badge
              class="inline-block align-middle"
              :count="item.count"
              :overflow-count="9999999999"
            />
          </div>
        </template>
        <remote-table
          v-if="noticeInfoState.activeKey === item.key"
          ref="tableRef"
          showSetting
          interfaceURL="/announcement-center/read-record"
          :y="noticeInfoState.scrollY"
          :sy="noticeInfoState.scrollY"
          hasAction
          @exportExcel="exportEvent"
          :apiParams="{
            scopeType: 1,
            type: item.key,
            responsibleId: noticeInfoState.userId
          }"
          :showSelection="false"
          :columns="noticeInfoState.noticeInfoColumns"
        >
          <template #effectiveTimeStrCR="{record}">
            {{ record.effectiveTimeStr
            }}<a-button
              danger
              v-if="record.expireFlag"
              size="small"
              class="ml-8px bg-color-[#FFF1F0]"
              >已过期</a-button
            >
          </template>
          <template #customTitle>
            <span class="inline-block align-middle mr-5px">状态</span>
            <a-tooltip>
              <template #title>必须点击【已阅读】按钮后，状态变更已读</template>
              <QuestionCircleOutlined class="inline-block align-middle" />
            </a-tooltip>
          </template>
          <template #isReadStrCR="{record}">
            <a-button
              class="bg-color-[#F6FFED] text-color-[#B7EB8F] border-solid border-color-[#B7EB8F]"
              size="small"
              v-if="record.isReadStr === '已读'"
              >{{ record.isReadStr }}</a-button
            >
            <a-button
              class="bg-color-[#FFF1F0]"
              size="small"
              danger
              v-if="record.isReadStr === '未读'"
              >{{ record.isReadStr }}</a-button
            >
          </template>
          <template #action="{record}">
            <a-button
              size="small"
              type="link"
              @click="
                ;(noticeInfoState.id = record.id),
                  (noticeInfoState.showDetail = true)
              "
            >
              详情
            </a-button>
          </template>
        </remote-table>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
  <noticeDetail
    v-if="noticeInfoState.showDetail"
    :showDetail="noticeInfoState.showDetail"
    :id="noticeInfoState.id"
    @close="noticeInfoState.showDetail = false"
    :toRead="refresh"
  />
</template>
<script setup>
import { inject, defineProps, provide } from 'vue'
import { useNoticeInfoList } from '../share'
import { FileTextOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import noticeDetail from './noticeDetail.vue'
const props = defineProps({
  id: {
    type: [String, Number],
    default: null
  }
})
const navBarState = inject('navBarState')
const { noticeInfoState, tableRef, refresh } = useNoticeInfoList(props)
provide('noticeInfoState', noticeInfoState)
</script>
<style lang="scss" scoped>
:deep(.portal-ant-list-item-meta-description) {
  font-size: 12px;
}
:deep(.portal-ant-list-item) {
  padding: 6px;
}
:deep(.portal-ant-badge-not-a-wrapper .portal-ant-scroll-number) {
  transform-origin: -50% 240% !important;
}
</style>
